import { Create, SimpleForm, TextInput } from 'react-admin';

const AccountCreate = (props) => (
    <Create {...props}>
        <SimpleForm redirect="list">
            <TextInput source="name" />
        </SimpleForm>
    </Create>
);

export default AccountCreate;